import { createRoot } from "react-dom/client";
import TrialAnalyzerApp from "~/components/analyzer/TrialAnalyzerApp";

function mountApp(): void {
  const container = document.getElementById("trial-analyzer-app");
  if (container && !container.dataset.reactMounted) {
    container.dataset.reactMounted = "true";
    const root = createRoot(container);
    root.render(<TrialAnalyzerApp />);
  }
}

document.addEventListener("DOMContentLoaded", mountApp);
mountApp();
